import {
    type SxProps,
    type Theme,
    alpha
} from '@mui/material/styles';

const styles = {
    carousel: (theme) => ({
        '.slick-arrow': {
            '&::after': {
                transform: 'translate(-50%, -50%) rotate(-45deg)'
            },
            '&::before': {
                mt: '2px',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            },
            '&::before, &::after': {
                backgroundColor: theme.colors.plantation,
                borderRadius: 2,
                content: '""',
                height: 4,
                left: '50%',
                opacity: 1,
                position: 'absolute',
                top: '50%',
                transformOrigin: 'center right',
                width: 14
            },

            '&:hover, &:focus-visible': {
                transform: 'translate(0) scale(1.05)'
            },

            ':focus-visible': {
                borderRadius: '999px',
                outline: `2px solid ${theme.colors.teal}`,
                outlineOffset: 2
            },

            alignItems: 'center',

            backgroundColor: 'transparent',

            border: `solid 1px ${theme.colors.plantation}`,
            borderRadius: '50%',
            bottom: {
                md: 'auto',
                xs: 0
            },
            display: 'flex !important',
            height: 40,
            justifyContent: 'center',
            position: 'absolute',
            top: {
                md: '50%',
                xs: 'auto'
            },
            transform: 'translate(0)',
            width: 40,
            zIndex: 1
        },
        '.slick-disabled': {
            display: 'none !important'
        },

        '.slick-list': {
            mx: {
                md: -2,
                xs: 0
            }
        },

        '.slick-next': {
            right: {
                md: '-62px',
                xs: 'calc(50% - 48px)'
            }
        },

        '.slick-prev': {
            '&:hover, &:focus-visible': {
                transform: 'translate(0) scaleX(-1) scale(1.05)'
            },

            left: {
                md: '-62px',
                xs: 'calc(50% - 48px)'
            },
            transform: 'translate(0) scaleX(-1)'
        },

        '.slick-slide': {
            boxSizing: 'border-box',
            px: 2
        },

        '.slick-slide > div > div': {
            width: '100% !important'
        },

        '.slick-slider': {
            pb: {
                md: 0,
                xs: '52px'
            }
        },

        '.slick-track': {
            pt: 1
        },

        mt: {
            md: 5,
            xs: 4
        },
        mx: -2
    }),

    container: {
        // Optional sections can supply their own leading divider. We show one
        // separator when it meets the advertisement's trailing divider.
        '> hr + hr': {
            display: 'none'
        },
        boxSizing: 'border-box',
        maxWidth: 1728,
        paddingTop: 5,
        width: '100%'
    },

    divider: (theme) => ({
        borderColor: theme.colors.mercury,
        borderWidth: 1,
        mb: {
            md: 9,
            xs: 3
        },
        mt: {
            md: 6,
            xs: 3
        }
    }),

    featuredSupporterWrapper: () => ({ }),

    header: {
        m: 0
    },

    thumbnailSmall: (theme) => ({
        boxShadow: `0px 0px 5px ${alpha(theme.colors.black, 0.22)}`, // ~ #00000038
        boxSizing: 'border-box',
        display: 'inline-block',
        img: {
            width: {
                lg: 150,
                md: 130,
                xs: 120
            }
        },
        mt: 1,
        p: 0.5
    }),

    wcSponsorSection: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        minHeight: {
            md: 90,
            xs: 100
        },
        px: 1,
        width: '100%'
    },

    wrapper: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        overflowX: 'hidden',
        width: '100%'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
